export default __webpack_public_path__ + "static/media/fo.e09e27c2.svg";